// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".newPasswordButton {\n    position: sticky;\n    bottom: 0;\n    opacity: 100%\n}\n", "",{"version":3,"sources":["webpack://./js/newPasswordButton.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,SAAS;IACT;AACJ","sourcesContent":[".newPasswordButton {\n    position: sticky;\n    bottom: 0;\n    opacity: 100%\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
